import { Link } from 'react-router-dom';
import './Button.css';

/**
 * Botón reutilizable.
 * - variant: 'primary' | 'secondary' | 'ghost' | 'accent' | 'danger' | 'dangerSoft'
 * - size: 'sm' | 'md' | 'lg'
 * - block: ocupa todo el ancho
 * - to: si se pasa, renderiza un <Link> de react-router con estilo de botón
 */
export default function Button({
  variant = 'primary',
  size = 'md',
  block = false,
  to,
  href,
  className = '',
  children,
  ...rest
}) {
  const cls = [
    'btn',
    `btn-${variant}`,
    `btn-${size}`,
    block ? 'btn-block' : '',
    className,
  ].filter(Boolean).join(' ');

  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...rest}>{children}</a>;
  return <button className={cls} {...rest}>{children}</button>;
}